<div
  class="cm-radio-group-button"
  [class.cm-radio-group-button-checked]="checked"
  [class.cm-radio-group-button-disabled]="disabled"
>
  <input
    type="radio"
    class="cm-radio-group-button-input"
    [id]="inputId"
    [checked]="checked"
    [disabled]="disabled"
    [attr.name]="name"
    [attr.value]="value"
    [required]="required"
    aria-invalid="false"
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledby"
    [attr.aria-describedby]="ariaDescribedby"
    [attr.aria-disabled]="disabled ? 'true' : null"
    (change)="onChange($event)"
  />
  <div class="cm-radio-group-button-circle"></div>
  <label class="cm-radio-group-button-label" [for]="inputId">
    <ng-content></ng-content>
  </label>
</div>
